import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Button } from '@popmenu/admin-ui';
import { Typography } from '@popmenu/common-ui';

import { withStyles } from '../../../utils/withStyles';
import styles from './styles';

import PopmenuLogoImg from '../../../assets/svg/popmenu_logo_white.svg';
import Grid from '../../../shared/Grid';
import SignUpForm from '../../invites/SignUpForm';
import SignInForm from '../../../shared/sessions/SignInForm';

const UserSignUpForm = ({ classes, email = null, facebookOauthDisabled, restaurantSlug = null }) => {
  const [showSignUp, setShowSignUp] = useState(true);
  const searchParams = new URLSearchParams(document.location.search);
  const isOauth = searchParams.get('oauth');

  const afterSignInOrUpRedirect = () => {
    if (!isOauth) {
      window.location.href = restaurantSlug ? `/${restaurantSlug}` : '/';
    }
  };

  return (
    <Grid container justifyContent="center" spacing={0} className={classes.container}>
      <Grid item xs={12} md={5} className={classes.logoContainer}>
        <div>
          <Typography color="white" variant="h5">
            <FormattedMessage
              defaultMessage="Welcome to"
            />
          </Typography>
          <PopmenuLogoImg className={classes.logo} />
        </div>
      </Grid>
      <Grid item xs={12} md={7} className={classes.signUpFormContainer}>
        <Grid container justifyContent="center" spacing={0}>
          {showSignUp ? (
            <Grid item xs={11} md={9} className={classes.signUpForm}>
              <Typography variant="h6">
                <FormattedMessage
                  defaultMessage="Let's Create Your Account"
                />
              </Typography>
              <br />
              <SignUpForm
                email={email}
                showAllFields={false}
                style={{ backgroundColor: '#fff' }}
                variant="outlined"
                onUserExists={() => setShowSignUp(false)}
                afterSignUp={() => afterSignInOrUpRedirect()}
              />
              <Typography align="center" variant="body1">
                <FormattedMessage
                  defaultMessage="Already have an account?&nbsp;"
                />
              </Typography>
              <Typography align="center" variant="body1">
                <Button
                  autoCapitalize="false"
                  onClick={() => setShowSignUp(false)}
                  variant="text"
                >
                  <FormattedMessage
                    defaultMessage="Sign-In"
                  />
                </Button>
              </Typography>
            </Grid>
          ) : (
            <Grid item xs={11} md={9} className={classes.signUpForm}>
              <br />
              <SignInForm
                email={email}
                facebookOauthDisabled={facebookOauthDisabled}
                style={{ backgroundColor: '#fff' }}
                variant="outlined"
                afterSignIn={() => afterSignInOrUpRedirect()}
              />
              <br />
              <Typography align="center" variant="body2">
                <Button
                  onClick={() => setShowSignUp(true)}
                  variant="text"
                >
                  <FormattedMessage
                    defaultMessage="Don't have an existing account?&nbsp;{signUp}"
                    values={{
                      signUp: (
                        <strong className={classes.red}>
                          <FormattedMessage
                            defaultMessage="Sign up"
                          />
                        </strong>
                      ),
                    }}
                  />
                </Button>
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

UserSignUpForm.propTypes = {
  classes: PropTypes.object.isRequired,
  email: PropTypes.string,
  facebookOauthDisabled: PropTypes.bool.isRequired,
  restaurantSlug: PropTypes.string,
};

export default withStyles(styles)(UserSignUpForm);
